const input = {
    username: 'Nombre de usuario',
    password: 'Contraseña',
    email: 'Correo electrónico',
    phone_number: 'Número de teléfono',
    student_number: 'Número de estudiante',
    registration_number: 'Número de matrícula',
    student_identifier_legend: 'Iniciar sesión con',
    confirm_password: 'Confirmar contraseña',
    search_region_code: 'Código de región de búsqueda',
    backup_code: 'Código de respaldo',
    code: 'Código',
    label_with_optional: '{{label}} (Opcional)',
};
export default Object.freeze(input);
